import { z } from 'zod'

import { nanoid } from '../../nanoid'

export const CMS_ID_LENGTH = 16

// The hyphen matters: ids minted by the database use Prisma's own nanoid alphabet, which
// includes it, so a pattern without it rejects roughly one page in five. `PUBLIC_FILE_ID_PATTERN`
// has always allowed it; this is the same alphabet.
const CMS_ID_PATTERN = /^[A-Za-z0-9_-]{16}$/

/**
 * Every id inside CMS JSON — blocks, repeatable sub-list rows, menu items — uses the same
 * generator as the relational ids, so a `LIKE '%<id>%'` prefilter over a JSON column cannot tell
 * the two apart and the where-used collectors stay uniform. The reference implementation used
 * cuid2 here; the only property that matters is that a text match is a real reference, and 16
 * nanoid characters carry ~95 bits.
 */
export const cmsIdSchema = z.string().regex(CMS_ID_PATTERN)

export const createCmsId = (): string => nanoid()
